import React, { Component } from 'react';
import * as CurrencyFormat from 'react-currency-format';
//import moment from 'moment';
//import { Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';

class FeeBreakdown extends Component {
    render() {
        const { t } = this.props
        const commissionPayments = this.props.commissionPayments;
        const commission = commissionPayments.map(item => Object.entries(item).map(field => field[1]));
        //const current = Object.keys(commissionPayments).map(key => commissionPayments[key].Current);
        //const currentStartDate = moment(current[0].startDate).format('DD-MM-YYYY')
        //const formattedDate = moment(currentStartDate).format('YYYY-MM-DD')

        return (
            // <div>Fee Break</div>

            <div style={{ marginTop: "20px", marginBottom: "20px" }}>
                <header className="adviserMenu">{t('commission') + " " + t('payment')}</header>
                <table className="superlifeLegacyPlan commissionsPayment" style={{ marginTop: "12px" }}>
                    <thead>
                        {/* <tr>
                            <th>{t('date')}</th>
                            <th>{t('transaction')}</th>
                            <th>{t('amount')}</th>
                            <th>{t('status')}</th>
                        </tr> */}
                        <tr>
                            <th>Date</th>
                            <th>Transaction</th>
                            <th>Amount</th>
                            {/* <th>Status</th> */}
                        </tr>
                    </thead>

                    <tbody>
                        {
                            commission.map(commission =>
                                commission.map((comm, key) =>
                                    <tr key={key}>
                                        <td style={{ textAlign: "center" }}>{comm.dueDate}</td>
                                        <td style={{ textAlign: "center" }}>{t('commission') + " " + t('payment')}</td>
                                        <td><CurrencyFormat value={Number(comm.payment).toFixed(2)}
                                            displayType={'text'}
                                            thousandSeparator={true}
                                            prefix={'$'} /></td>
                                        {/* {new Date(comm.month).getMonth() === new Date(formattedDate).getMonth() 
                                            ? <td><Link to='/adv/commissionPayment/due'>{t('due')}</Link></td> 
                                            : <td><Link to='/adv/commissionPayment/paid'>{t('paid')}</Link></td>} */}
                                    </tr>
                                ))}
                    </tbody>
                </table>

            </div>
        )
    }
}

export default withTranslation()(FeeBreakdown);